module.exports = require("./hr-HR");